import * as React from 'react';

const AlarmBell = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.00434C10.6392 2.01044 10.3511 2.02503 10.0863 2.05989C6.94518 2.47342 4.47342 4.94518 4.05989 8.08632C3.99989 8.54207 3.99993 9.06713 4 9.91256C4 9.94133 4 9.97048 4 10V18H1V20H23V18H20L20 9.91253C20.0001 9.06711 20.0001 8.54206 19.9401 8.08632C19.5266 4.94518 17.0548 2.47342 13.9137 2.05989C13.6489 2.02503 13.3608 2.01044 13 2.00434V0H11V2.00434ZM18 18V10C18 9.03937 17.9978 8.6559 17.9572 8.34737C17.6618 6.1037 15.8963 4.33816 13.6526 4.04278C13.3441 4.00216 12.9606 4 12 4C11.0394 4 10.6559 4.00216 10.3474 4.04278C8.1037 4.33816 6.33816 6.1037 6.04278 8.34737C6.00216 8.6559 6 9.03937 6 10V18H18ZM12 24C10.1345 24 8.83546 23.056 8.16795 22.0547L9.83205 20.9453C10.1645 21.444 10.8655 22 12 22C13.1345 22 13.8355 21.444 14.1679 20.9453L15.8321 22.0547C15.1645 23.056 13.8655 24 12 24Z"
      fill="#8A8B8D"
    />
  </svg>
);

export default AlarmBell;
